import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["flush", "children", "as"];
import React, { createContext, forwardRef, useState, useContext, useEffect } from 'react';
import Card from 'components/Card';
import useUniqueId from 'hooks/useUniqueId';
export var PanelTitleContext = /*#__PURE__*/createContext(undefined);
export function usePanelTitleId(id) {
  var panelHeadingId = useUniqueId();
  var idToRegister = id || panelHeadingId;
  var setPanelTitleId = useContext(PanelTitleContext);
  useEffect(function () {
    if (setPanelTitleId) {
      setPanelTitleId(idToRegister);
    }
  }, [idToRegister, setPanelTitleId]);
  return idToRegister;
}
var PanelWrapper = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var flush = _ref.flush,
    children = _ref.children,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'section' : _ref$as,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    panelTitleId = _useState2[0],
    setPanelTitleId = _useState2[1];
  return /*#__PURE__*/React.createElement(PanelTitleContext.Provider, {
    value: setPanelTitleId
  }, /*#__PURE__*/React.createElement(Card, _extends({}, otherProps, {
    as: as,
    "aria-labelledby": panelTitleId,
    ref: ref,
    size: "small",
    p: flush ? undefined : 's',
    mb: "xs"
  }), children));
});
PanelWrapper.displayName = 'PanelWrapper';
export default PanelWrapper;